import React, {Component} from "react";
import Login from "../Login/Login";
import RegisterPopup from "../Register/RegisterPopup";

class ModalRegister extends Component {
    render() { 
        return (
            <div id="modal-register" className="modal fade p-0">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header" data-dismiss="modal">
                            Register <i className="far fa-times-circle icon-close" />
                        </div>
                        <div className="modal-body">
                            <RegisterPopup title="Register Now"/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
export default ModalRegister;